import axios from 'axios'

const configuredAxiosInstance = () => {
  return axios.create({
    withCredentials: true,
  })
}

export default configuredAxiosInstance()
